// Components
import Text from '@components/helpers/text/Text'

const SelectionTitle = ({ text }: { text: string }) => {
  return (
    <Text tagName="h1" variant="title-4" spacing={{ sm: 8 }}>
      {text}
    </Text>
  )
}

export default SelectionTitle
